
/* eslint no-control-regex: 0 */
export default {
  name: 'UtitMixin',
  filters: {
    sn_utilMixin_truncate (value, length, replacementString = '...') {
      if (value.length > length) {
        return value.slice(0, length) + replacementString
      }
      return value
    },
    sn_utilMixin_formatPhone (phone) {
      return `(${phone.substr(0, 3)}) ${phone.substr(3, 3)}-${phone.substr(6, 4)}`
    }
  },
  methods: {
    sn_utilMixin_copyToClipBoard (value) {
      const el = document.createElement('textarea')
      el.value = value
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
    },
    sn_utilMixin_specialCharacterCheck (value) {
      const pattern = /^[\x00-\x7F]*$/
      return pattern.test(value) || 'Invalid characters'
    },
    sn_utilMixin_numbersOnlyCheck (value) {
      const pattern = /^(\d)*$/
      return pattern.test(value) || 'Please enter a valid number'
    },
    sn_utilMixin_deformatPhone (phone) {
      return phone.replace(/[^0-9]/g, '')
    }
  }
}
